export default __webpack_public_path__ + "static/media/you-can-do-it.0bc737da.jpg";